export default __webpack_public_path__ + "static/media/ic_merchandise.75f4a4b9.svg";